import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";

import { FullPageChatLayout } from "./FullPageChatLayout";

jest.mock("@metalmind-ab/mmagent-chat-ui", () => ({
  ChatMessage: ({ message }: { message: any }) => (
    <div data-testid={`chat-message-${message.id}`}>{message.content}</div>
  ),
  JobProgressIndicator: () => null,
  useChatStore: (selector: (state: any) => any) =>
    selector({
      backgroundJobs: [],
      removeBackgroundJob: jest.fn(),
      messages: [],
    }),
}));

beforeAll(() => {
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
  Object.defineProperty(URL, "createObjectURL", {
    configurable: true,
    value: jest.fn(() => "blob:test-url"),
  });
  Object.defineProperty(URL, "revokeObjectURL", {
    configurable: true,
    value: jest.fn(),
  });
});

const existingMessage = {
  id: "msg-1",
  role: "assistant",
  content: "Already loaded message",
  createdAt: new Date().toISOString(),
} as any;

const renderLayout = (
  overrides: Partial<React.ComponentProps<typeof FullPageChatLayout>> = {},
) =>
  render(
    <FullPageChatLayout
      messages={[existingMessage]}
      onSendMessage={jest.fn()}
      isLoading={false}
      conversations={[]}
      onLoadConversation={jest.fn()}
      onNewConversation={jest.fn()}
      onSearchConversations={jest.fn()}
      onLoadMoreConversations={jest.fn()}
      conversationsLoading={false}
      currentConversationId={1}
      hasOlderMessages
      onLoadOlderMessages={jest.fn()}
      {...overrides}
    />,
  );

describe("FullPageChatLayout older-messages load-failed surface", () => {
  it("surfaces a non-retryable failure beside the Load earlier messages button without hiding the currently visible messages", () => {
    const onLoadOlderMessages = jest.fn();
    renderLayout({ olderMessagesLoadFailed: true, onLoadOlderMessages });

    expect(screen.getByText("Already loaded message")).toBeInTheDocument();
    const button = screen.getByRole("button", {
      name: /load earlier messages/i,
    });
    expect(button).toBeDisabled();
    fireEvent.click(button);
    expect(onLoadOlderMessages).not.toHaveBeenCalled();
    expect(
      screen.getByTestId("older-messages-load-failed"),
    ).toHaveTextContent("Earlier messages could not be loaded.");
  });

  it("does not show a failure message when the last older-page fetch has not failed", () => {
    renderLayout({ olderMessagesLoadFailed: false });

    expect(
      screen.queryByTestId("older-messages-load-failed"),
    ).not.toBeInTheDocument();
  });
});
